import { Duration, DurationOptions } from "luxon";
import { roundToNearestQuarter } from "./roundToNearest";

export const getDurationAsHours = (durationText: string, durationOpts?: DurationOptions) => {
  const numHours = Duration.fromISO(durationText, durationOpts).as("hours");
  return roundToNearestQuarter(numHours);
};
